var React = require( 'react' );
var createReactClass = require('create-react-class');
var _ = require('lodash');
var MatrixRowItem = require('./matrixRowItem.jsx');

var MatrixRow = createReactClass({
  render: function() {
    const { label = '' } = this.props;
    // const truncatedLabel = (label.length > 23) ? label.slice(0, 23) : label;

    var matrixCells = this.props.choices.map(function(choice, key) {
      const { value, unique = false } = choice;

      if(Object.keys(this.props.userResponse).length > 0) {
        var checked = _.some(this.props.userResponse, (response) => {
          return (+response.value === value) &&
            (+response.rowValue === this.props.rowValue);
        });        
      }
      
      // Old checked code before userResponse changed to array
      // var checked = Object.keys(this.props.userResponse).length > 0 && 
      //  (+this.props.userResponse.value === choice.value) &&
      //  (+this.props.userResponse.rowValue === this.props.rowValue);

      return (
        <MatrixRowItem
          name={this.props.name + '_' + choice.tag}
          //label={this.props.label + '_' + choice.label}
          label={this.props.label}
          key={this.props.name + '-choice-' + key}
          value={value}
          rowValue={this.props.rowValue}
          checked={checked}
          allowMulti={this.props.allowMulti}
          unique={unique}
          handleResponse={this.props.handleResponse} />
      );
    }.bind(this));

    return (
      <div className="option-row">
          <div className="title">
            <h5>{label}</h5>
          </div>
          {matrixCells}
      </div>
    );
  }
});

module.exports = MatrixRow;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/matrix/matrixRow.jsx